import { AgentConfigData, AgentInstructionOptionId } from "@jugl-web/rest-api";

export const DEFAULT_AGENT_INSTRUCTIONS_BY_OPTION: Record<
  AgentInstructionOptionId,
  string
> = {
  "custom-prompt": "",
  "customer-support-agent":
    "You are a Customer Support Agent. Be empathetic, clear, and concise. Resolve user issues step by step, ask follow-up questions when details are missing, and confirm the final outcome.",
  "service-agent":
    "You are a Service Agent. Help users with setup, troubleshooting, and service-related requests. Explain actions in simple language and provide practical next steps.",
  "sales-agent":
    "You are a Sales Agent. Understand customer needs first, suggest the most relevant offer, highlight key benefits, and guide the user toward the next conversion step.",
};

export const DEFAULT_ESCALATE_TO_HUMAN_MESSAGE: AgentConfigData["when_to_handover"] =
  "When the user asks to connect with a human representative, Before handing over to human representative, if you identify any opportunity to collect lead information such as name, email, phone number, etc. then you should collect the lead information.";

export const DEFAULT_WHEN_TO_COLLECT_LEAD: AgentConfigData["when_to_collect_lead"] =
  "When the customer requests to talk to a human representative, or when the customer's issue cannot be resolved through automated assistance.";

export const DEFAULT_AGENT_STYLE: Pick<
  AgentConfigData,
  "tone" | "emoji_usage" | "response_length"
> = {
  tone: "business",
  emoji_usage: "none",
  response_length: 20,
};

export const MS_PER_MINUTE = 60000;
